import { Component, inject } from '@angular/core';
import { AppTitleService } from '../../services/app-title.service';

@Component({
    selector: 'app-carpata',
    imports: [],
    templateUrl: './carpata.component.html',
    styleUrl: './carpata.component.scss'
})
export class CarpataComponent {
  constructor() {
    inject(AppTitleService).setTitle('Carpetas virtuales');
  }
}
